import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Breadcrumbs,
  Link,
  Container,
  Dialog,
  DialogActions,
  TableFooter,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Button,
  Typography,
  FormControlLabel,
  Snackbar,
  Backdrop,
  DialogContent,
  ListItemText,
  ListItem,
  List,
  CardHeader,
  IconButton,
  Tooltip
} from '@material-ui/core';
import Page from 'src/components/Page';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import { DatePicker } from "@material-ui/pickers";
import Paper from '@material-ui/core/Paper';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart as Chart1 } from "chart.js";
import Chart from 'react-chartjs-2';
import { FaGalacticSenate } from 'react-icons/fa';
Chart1.register(ChartDataLabels);

var formatter = Intl.NumberFormat('en', { notation: 'compact' });

const useStyles = makeStyles((theme) => ({
  topRow: {
    fontSize: 45,
    color: '#495057',
    fontWeight: 500,
    marginBottom: '1.5rem'
  },
  title: {
    fontSize: 16,
    color: '#495057',
    marginBottom: '1.5rem'
  },
  headerSecondary: {
    fontSize: 12,
  },
  badge: {
    color: '#3f80ea !important',
    backgroundColor: '#e0eafc !important',
    float: 'right'
  },
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.white,
  },
  tableContainer: {
    maxHeight: 250,
  },
  tableGrid: {
    height: 280,
  },
  serviceShopBG: {
    backgroundImage: 'url("/images/shopcircle.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  repairBG: {
    backgroundImage: 'url("/images/repaircircle.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  repeatedRepairBG: {
    backgroundImage: 'url("/images/repeatedrepaircircle.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  technicianBG: {
    backgroundImage: 'url("/images/techniciancircle.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  flsBG: {
    backgroundImage: 'url("/images/fls.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  AverageRepairBG: {
    backgroundImage: 'url("/images/averagerepair.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  ForDaysRepairBG: {
    backgroundImage: 'url("/images/4daysrepair.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  MoreThan10DaysRepairBG: {
    backgroundImage: 'url("/images/10daysrepair.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPositionX: 'right'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  barDiv: {
    position: 'relative'
  },
  barNoData: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '200px',
    height: '50px',
    margin: 'auto',
    textAlign: 'center',
    fontSize: '120%'
  }
}));
const COLORS = [
  '#003f5c',
  '#7a5195',
  '#ef5675',
  '#ff764a',
  '#bc5090',
  '#374c80',
  '#ffa600',
  '#a4d8b2',
  '#054f7c',
  '#f7a35c',
  '#f45b5b',
  '#284c42',
  '#538e92',
  '#1f6aa3',
  '#9492b9'
];
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const percentageOptions = {
  max: 100,
  min: 0,
  ticks: {
    padding: 10,
    beginAtZero: true,
    callback: function (value) {
      return value + '%';
    },
  },
  grid: {
    display: false,
  },
}
const pluginOptions = (color, percentage = '') => {
  return {
    display: true,
    backgroundColor: function (context) {
      return context.active ? context.dataset.backgroundColor : 'white';
    },
    borderColor: function (context) {
      return context.dataset.backgroundColor;
    },
    borderRadius: function (context) {
      return context.active ? 0 : 32;
    },
    borderWidth: 3,
    color: function (context) {
      return context.active ? 'white' : context.dataset.backgroundColor;
    },
    font: {
      weight: 'bold'
    },
    formatter: function (value, context) {
      value = formatter.format(value);
      return context.active
        ? context.dataset.label.replaceAll(' ', '\n') + '\n' + value + percentage
        : value;
    },
    offset: 8,
    padding: 5,
    textAlign: 'center'
  }
}
const barOptions = {
  indexAxis: 'x',
  scales: {
    xAxes: {
      stacked: true,
      ticks: {
        padding: 10,
      },
      grid: {
        display: false,
      },
    },
    yAxes: {
      stacked: true,
      ticks: {
        beginAtZero: true,
        padding: 10,
      },
      grid: {
        display: false,
      },
    }
  },
  plugins: {
    datalabels: {
      display: false
    }
  },
  hover: {
    mode: 'index',
    intersect: false
  },
  transitions: {
    show: {
      animations: {
        x: {
          from: 0
        },
        y: {
          from: 0
        }
      }
    },
    hide: {
      animations: {
        x: {
          to: 0
        },
        y: {
          to: 0
        }
      }
    },

  },
};
const lineOptions = {
  indexAxis: 'x',
  plugins: {
    datalabels: {
      display: false,
      backgroundColor: function (context) {
        return context.active ? context.dataset.backgroundColor : 'white';
      },
      borderColor: function (context) {
        return context.dataset.backgroundColor;
      },
      borderRadius: function (context) {
        return context.active ? 0 : 32;
      },
      borderWidth: 3,
      color: function (context) {
        return context.active ? 'white' : context.dataset.backgroundColor;
      },
      font: {
        weight: 'bold'
      },
      formatter: function (value, context) {
        value = Math.round(value * 100) / 100;
        return context.active
          ? context.dataset.label + '\\n' + value + '%'
          : Math.round(value);
      },
      offset: 8,
      padding: 5,
      textAlign: 'center'
    }
  },
  scales: {
    xAxes: {
      ticks: {
        padding: 10,
      },
      grid: {
        display: false,
      },
    },
    yAxes: {
      ticks: {
        padding: 10,
        beginAtZero: true,
      },
      grid: {
        display: false,
      },
    }
  },
  hover: {
    mode: 'index',
    intersect: false
  },
  transitions: {
    show: {
      animations: {
        x: {
          from: 0
        },
        y: {
          from: 0
        }
      }
    },
    hide: {
      animations: {
        x: {
          to: 0
        },
        y: {
          to: 0
        }
      }
    }
  },
};
const pieOptions = {
  plugins: {
    tooltip: {
      padding: 15,
    },
    legend: {
      display: false
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    xAxes: {
      display: false,
    },
    yAxes: {
      display: false,
    },
    x: {
      display: false,
    },
    y: {
      display: false,
    }
  },
  transitions: {
    show: {
      animations: {
        x: {
          from: 0
        },
        y: {
          from: 0
        }
      }
    },
    hide: {
      animations: {
        x: {
          to: 0
        },
        y: {
          to: 0
        }
      }
    }
  },
};

function Dashboard(props) {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const dispatch = useDispatch();
  const SessionUser = getUser();

  const dashboardFromSlice = JSON.parse(localStorage.getItem("dashboard"))?.dashboardData;
  const dashboardFromSliceLastUpdate = JSON.parse(localStorage.getItem("dashboard"))?.lastUpdateDate;

  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardDataLoaded, setDashboardDataLoaded] = useState(false);
  const [date, changeDate] = useState(new Date());

  const [RepairRatesData, setRepairRatesData] = useState();
  const [AVGAppointmentComplianceData, setAVGAppointmentComplianceData] = useState();
  const [RepeatedRepairData, setRepeatedRepairData] = useState();
  const [AverageRepairTimeData, setAverageRepairTimeData] = useState();
  const [TotalCompletedRepairsData, setTotalCompletedRepairsData] = useState();
  const [UnitCostsData, setUnitCostsData] = useState();

  useEffect(() => {

    //12 saatten fazla süre geçtiyse veya daha önce veri çekilmediyse veriyi yenile
    if (!dashboardFromSliceLastUpdate || moment(dashboardFromSliceLastUpdate).add(12, 'hours') <= moment()) {
      //1 - Service Shop
      //2 -> Head Office
      var page = 1
      axios.get('/GetDashboardData/' + page + '/' + SessionUser.ServiceShopId).then(response => {
        setDashboardData(response.data[0])

        var data = {
          dashboardData: response.data[0],
          lastUpdateDate: Date()
        }
        localStorage.setItem("dashboard", JSON.stringify(data))
        setDashboardDataLoaded(true);
      })
    }
    else {
      setDashboardData(dashboardFromSlice)
      setDashboardDataLoaded(true);
    }
  }, [dashboardFromSliceLastUpdate]);
  
  useEffect(() => {
    if (!date) {
      return;
    }
    createBarGroup(
      dashboardData?.UnitCosts,
      UnitCostsData,
      setUnitCostsData,
    )
    createBarGroup(
      dashboardData?.RepairRates,
      RepairRatesData,
      setRepairRatesData,
    )
    createBarGroup(
      dashboardData?.AverageRepairTime,
      AverageRepairTimeData,
      setAverageRepairTimeData,
      false
      ['#bc5090']
    )
    createBarGroup(
      dashboardData?.AVGAppointmentCompliance,
      AVGAppointmentComplianceData,
      setAVGAppointmentComplianceData,
    )
    createBarGroup(
      dashboardData?.TotalCompletedRepairs,
      TotalCompletedRepairsData,
      setTotalCompletedRepairsData,
      FaGalacticSenate
      ['#374c80']
    )
    createBarGroup(
      dashboardData?.RepeatedRepair,
      RepeatedRepairData,
      setRepeatedRepairData,
      false
      ['#ff764a']
    )
  
  }, [date]);
 
  const loading = <CircularProgress
    status="loading"
    style={{ margin: 0, padding: 0, width: '20px', height: '20px' }}
  />

  const topRowData = [
    {
      Title: t('lblTechnician'),
      Value: dashboardDataLoaded ? dashboardData?.TechnicianCount?.toLocaleString(undefined,{maximumFractionDigits: 1}) || 0 : loading,
      Text: '',
      Class: 'technicianBG'
    },
    {
      Title: t('lblNpsScore'),
      Value: dashboardDataLoaded ? dashboardData?.NPSScore ? dashboardData?.NPSScore?.toLocaleString(undefined,{maximumFractionDigits: 1}): 0 : loading,
      Text: '',
      Class: 'flsBG'
    },
    {
      Title: t('lblProductExchangeRate'),
      Value: dashboardDataLoaded ? dashboardData?.ProductExchangeRate ? dashboardData?.ProductExchangeRate?.toLocaleString(undefined,{maximumFractionDigits: 1}) : 0 : loading,
      Text: t('lblLast12Month'),
      Class: 'repairBG'
    },
    {
      Title: t('lblRepeatedRepair'),
      Value: dashboardDataLoaded ? dashboardData?.RepeatedRepairLast12Month ? dashboardData?.RepeatedRepairLast12Month?.toLocaleString(undefined,{maximumFractionDigits: 1}) + '%'  : 0 : loading,
      Text: '',
      Class: 'repeatedRepairBG'
    },
    {
      Title: t('lblTotalRepair'),
      Value: dashboardDataLoaded ? dashboardData?.TotalRepair?.toLocaleString(undefined,{maximumFractionDigits: 1}) || 0 : loading,
      Text: '',
      Class: 'repairBG'
    },
    {
      Title: t('lblAverageRepairTime'),
      Value: dashboardDataLoaded ? dashboardData?.AverageRepair?.toLocaleString(undefined,{maximumFractionDigits: 1}) || 0 : loading,
      Text: t('lblLast12Month'),
      Class: 'AverageRepairBG'
    },
    {
      Title: t('lblFourDaysRepairRate'),
      Value: dashboardDataLoaded ? dashboardData?.FourDaysRepairRate ? dashboardData?.FourDaysRepairRate?.toLocaleString(undefined,{maximumFractionDigits: 1}) + '%' : 0 : loading,
      Text: t('lblLast12Month'),
      Class: 'ForDaysRepairBG'
    },
    {
      Title: t('lblMoreThan10DaysRepairRate'),
      Value: dashboardDataLoaded ? dashboardData?.MoreThan10DaysRepairRate ? dashboardData?.MoreThan10DaysRepairRate?.toLocaleString(undefined,{maximumFractionDigits: 1}) + '%' : 0 : loading,
      Text: t('lblLast12Month'),
      Class: 'MoreThan10DaysRepairBG'
    },
  ]
  const createBarGroup = (dataset, data, setData, total, color = COLORS) => {
    var tempData;
    var values = [];
    if (dataset) {
      var c = 0;
      var length = moment(date).year() == moment().year() ? moment().month() + 1 : 12;
      dataset.map((i, index) => {
        if (i.Year != moment(date).year() || i.Month > length) {
          return false;
        }
        if (values.findIndex(a => a?.label == i.Type) == -1) {
          var value = {};
          value.data = Array(length).fill("0");
          value.label = i.Type;
          value.barThickness = 20;
          value.tension = 0.3;
          value.minBarLength = 10;
          value.backgroundColor = color[c % color.length];
          value.key = i.Type;
          c++;
          values.push(value);
        }

        var j = values.findIndex(a => a.label == i.Type)
        values[j].data[i.Month - 1] += i.Value || 0;
      })
      tempData = {
        labels: months.slice(0, length),
        datasets: values || []
      };
      if (total) {
        tempData = totalData(tempData);
      }
      if (JSON.stringify(data) != JSON.stringify(tempData)) {
        setData(tempData);
      }
    }


  }
  const percentageData = (data, findTotal) => {
    if (data?.datasets?.length > 0) {
      if (findTotal) {
        var total = Array(data.datasets[0].data.length).fill(0);
        data.datasets.map(i => {
          var value = i.data;
          total = total.map(function (num, idx) {
            return num + parseFloat(value[idx]);
          })
        })
        data.datasets = data.datasets.filter(i => i.label != "Other");
        data.datasets.map((j, index) => {
          var temp = [];
          for (var i = 0; i < j.data.length; i++) {
            if (total[i] != 0) {
              temp.push((parseFloat(j.data[i]) * 100 / total[i]).toFixed(1));
            }
            else {
              temp.push(0)
            }
          }
          j.data = temp;
          j.datalabels = pluginOptions(j.backgroundColor, '%');
        })
      }
      else {
        data.datasets.map((j, index) => {
          var temp = [];
          for (var i = 0; i < j.data.length; i++) {
            temp.push((parseFloat(j.data[i]) * 100).toFixed(1));
          }
          j.data = temp;
          j.datalabels = pluginOptions(j.backgroundColor, '%');
        })
      }
    }
    return data;
  }
  const totalData = (data) => {
    if (data?.datasets?.length > 0) {
      var totalData = Array(data.datasets[0].data.length).fill(0)
      data.datasets.map(i => {
        var temp = i.data;
        totalData = totalData.map(function (num, idx) {
          return num + parseInt(temp[idx]);
        })
      })
      var value = {};
      value.data = totalData;
      value.label = 'Total';
      value.type = 'line';
      value.tension = 0.3;
      value.backgroundColor = '#333';
      value.datalabels = pluginOptions('#333');
      data.datasets = [value].concat(data.datasets);
    }
    return data;
  }
  const clearData = () => {
    setRepairRatesData()
    setAVGAppointmentComplianceData()
    setRepeatedRepairData()
    setAverageRepairTimeData()
    setTotalCompletedRepairsData()
    setUnitCostsData()

  }
  const showBarGroup = (type, title, data, percentage) => {
    var chartOptions = JSON.parse(JSON.stringify(type == 'bar' ? barOptions : lineOptions))
    if (percentage) {
      chartOptions.scales.yAxes = percentageOptions
    }

    if (dashboardData && !data?.datasets?.length) {
      data = {
        labels: months.slice(0, 12),
        datasets: [
          {
            label: t('lblNoData'),
            data: [],
            backgroundColor: COLORS[0],
            minBarLength: 10,
          }
        ]
      };
    }
    return (
      <Card>
        <CardContent>
          <Typography className={classes.title} variant="h5" component="h5">
            {title}
            <DatePicker style={{ float: 'right', width: 75, cursor: 'pointer' }}
              views={["year"]}
              maxDate={moment()}
              inputVariant="outlined"
              size="small"
              value={date}
              onChange={changeDate}
              onOpen={() => clearData()}
            />
          </Typography>

          {dashboardDataLoaded ?
            <div className={classes.barDiv}>
              <Chart type={type} data={data} options={chartOptions} />

              {data.datasets[0].data.length == 0 && <p className={classes.barNoData}>{t('lblNoData')}</p>}
            </div>
            : loading
          }


        </CardContent>
      </Card>
    )
  }
  const circleChart = (type, dataset, title) => {
    var data = {
      labels: [t('lblNoData')],
      datasets: [
        {
          data: [],
          backgroundColor: COLORS,
        }
      ],
    };
    var total = 0;
    if (dataset) {
      var labels = []
      var values = []
      dataset.map(i => {
        labels.push(i.Type);
        values.push(i.Value);
        total += i.Value;
      })
      var total = values.reduce(function (a, b) { return a + b; }, 0);
      data = {
        labels: labels,
        datasets: [
          {
            data: values,
            backgroundColor: COLORS,
          }
        ],
      };
    }
    return (
      <Card>
        <CardContent>
          <Typography className={classes.title} style={{ textAlign: 'center' }} variant="h5" component="h5">
            {title}
          </Typography>
          {
            dashboardDataLoaded ?
              <Grid container alignItems="center" justify="center">
                <Grid item xs={8}>
                  <Chart type={type} data={data} options={pieOptions} />
                </Grid>
                <Grid item className={classes.tableGrid} xs={12}>
                  <br /><br />
                  {dataset ? <TableContainer className={classes.tableContainer} component={Paper}>
                    <Table className={classes.table} stickyHeader aria-label="simple table">
                      <TableHead className={classes.head}>
                        <TableRow>
                          <TableCell>{t('lblType')}</TableCell>
                          <TableCell align="right">{t('lblShare')}</TableCell>
                          <TableCell align="right">{t('lblTotal')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataset?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="left">{row.Type}</TableCell>
                            <TableCell align="right">{Math.round(row.Value * 100 / total)}%</TableCell>
                            <TableCell align="right">{row.Value.toLocaleString(undefined,{maximumFractionDigits: 1})}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                          <TableCell align="left"></TableCell>
                          <TableCell align="right">100%</TableCell>
                          <TableCell align="right">{total.toLocaleString(undefined,{maximumFractionDigits: 1})}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                    :
                    <div className={classes.barDiv}>
                      <p className={classes.barNoData}>{t('lblNoData')}</p>
                    </div>
                  }
                </Grid>
              </Grid>
              : loading
          }
        </CardContent>
      </Card>
    )
  }
  if (
    SessionUser?.ServiceShopTypeId === 15 &&
    SessionUser?.TenantId === 118
  ) {
    return null;
  }

  return (
    <>
      <Page className={classes.root} title="">

        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Breadcrumbs>
              <Link color="inherit">Sirius</Link>
              <Typography color="textPrimary">{t('lblDashboard')}</Typography>
            </Breadcrumbs>
            <Grid container spacing={1}>
              {topRowData.map((row, index) => (
                <Grid key={index} item xs={12} sm={3}>
                  <Card>
                    <CardContent className={classes[row.Class]}>
                      <Typography className={classes.title} variant="h5" component="h5">
                        {row.Title}
                      </Typography>
                      <Typography className={classes.topRow} component="div">
                        {row.Value}
                      </Typography>
                      <Typography className={classes.headerSecondary} variant="body2" color="textSecondary" component="p">
                        {row.Text} &nbsp;
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}


              <Grid item xs={12} sm={3}>
                {circleChart(
                  'doughnut',
                  dashboardData?.WorkCaseStatusDistribution,
                  t('lblWorkCaseStatus')
                )}
              </Grid>
              <Grid item xs={12} sm={3}>
                {circleChart(
                  'doughnut',
                  dashboardData?.WarrantyTypeDistribution,
                  t('lblWarrantyTypes')
                )}
              </Grid>
              <Grid item xs={12} sm={3}>
                {circleChart(
                  'doughnut',
                  dashboardData?.RepairPeriodDistribution,
                  t('lblRepairPeriodDistribution')
                )}
              </Grid>
              <Grid item xs={12} sm={3}>
                {circleChart(
                  'doughnut',
                  dashboardData?.NPSDistribution,
                  t('lblNPSDistribution')
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                {showBarGroup('bar', t('lblUnitCosts'), UnitCostsData, false, true)}
              </Grid>
              <Grid item xs={12} sm={6}>
                {showBarGroup('line', t('lblRepairRates'), percentageData(RepairRatesData, true), true, false)}
              </Grid>

              <Grid item  xs={12} sm={6}>
                {showBarGroup('bar', t('lblAverageRepairTime'), AverageRepairTimeData, false, false)}
              </Grid>
              <Grid item xs={12} sm={6}>
                {showBarGroup('line', t('lblAVGAppointmentCompliance'), AVGAppointmentComplianceData, false, false)}
              </Grid>

              <Grid item xs={12} sm={6}>
                {showBarGroup('bar', t('lblTotalCompletedRepairs'), TotalCompletedRepairsData, false, false)}
              </Grid>

              <Grid item xs={12} sm={6}>
                {showBarGroup('bar', t('lblRepeatedRepair'), RepeatedRepairData, false, false)}
              </Grid>

            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
}
export default Dashboard;
